/**
 * datefns formats
 * https://date-fns.org/v2.16.1/docs/format
 */
export enum DateFormatEnum {
    DATE = 'MM/dd/yyyy',
    ABREV_DAY_AND_PADDED_MONTH_AND_DAY = 'EEEEEE MM/dd',
    ABREV_DAY_AND_PADDED_MONTH_AND_DAY_LONG = 'EEE MM/dd',
    ABREV_DAY_COMMA_MONTH_AND_DAY = 'eee, MMM d',
    PADDED_MONTH_AND_DAY = 'MM/dd',
    ABREV_MONTH_AND_YEAR = 'MMM yyyy',
    ABREV_DAY_AND_DATE = 'eee MM/dd/yyyy',
    DATE_AND_TIME = "MM/dd/yyyy 'at' h:mma",
    MONTH_AND_DAY_COMMA_YEAR = 'MMMM d, yyyy',
    SHORT_MONTH_AND_DAY_COMMA_YEAR = 'MMM d, yyyy',
    LONG_LOCALIZED_TIME = 'h:mmaaa',
    ABREV_MONTH_AND_DATE = 'MMM d',
    ABREV_MONTH = 'MMM',
    JSON_DATE_WITHOUT_ZONE = "yyyy-MM-dd'T'HH:mm:ss",
    JSON_DATE_YEAR_MONTH_DAY = 'yyyy-MM-dd',
}
